






















import Vue from "vue";
import Modal from "@/components/root/modal/Modal.vue";
import { ModalConfig } from "@/components/root/modal";
import VirtualTable from "@/components/table/VirtualTable.vue";
import { table_config } from "./table.config";
import OnPremiseTableRow from "./OnPremiseTableRow.vue";
import { onBeforeUnmount, onMounted } from "@vue/composition-api";
import { FileSearchItem } from "../data/model";
import { UseCollection } from "@/common/composition/use-collection";
import { get_finding_entities } from "@/common/api/findings/findings.api";
export default Vue.extend({
  components: {
    Modal,
    VirtualTable,
  },
  /* label_id,label_name, session_id */
  props: ["modalData"],
  setup(props, { emit }) {
    const modal_config: ModalConfig = {
      title: "",
      desc: "",
      blank: true,
      backdropDismiss: true,
      withTopRightCloseBtn: true,
      width: "110rem",
      height: "70rem",
    };

    const {
      items,
      is_loading,
      load_items,
      load_more_items,
      clear,
      has_no_results,
    } = UseCollection<
      FileSearchItem,
      { cursor: string }
      // @ts-ignore
    >(async ({ cursor }) => {
      // @ts-ignore
      const session_id: string = props.modalData.session_id;
      // @ts-ignore
      const label_id: string = props.modalData.label_id;
      return await get_finding_entities("File")({
        application: "network_file_system",
        service: "onprem_fs",
        axis_z: {
          type: "Session",
          value: session_id,
        },
        type: "sensitive_information",
        cursor,
        label_ids: [label_id],
      });
    });

    onMounted(async () => {
      await load_items({ cursor: "" });
    });

    onBeforeUnmount(() => {
      clear();
    });

    return {
      modal_config,
      table_config,
      OnPremiseTableRow,
      has_no_results,
      is_loading,
      load_more_items,
      items,
    };
  },
});
